const Joinus = () => {
  const colors = ["#f4b1b8", "#e9536c", "#ffc250", "#1eacc0"];
  return (
    <div className="overflow-hidden">
      <section className='joinpadding service-position'>
        <div className='container'>
          <div className='joinus-bg-round'>
            {colors.map((color, i) => (
              <div
                data-aos={`fade-${i === 0 ? "down" : i === 1 ? "right" : i === 2 ? "up" : i === 3 ? "down" : ""}`} data-aos-delay="1000"
                key={i}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                }}
                className={`dot_color_${i + 1}`}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="">
                  <h4
                    className="blackjoin-service-heading text-center font-align"
                    style={{ fontSize: "30px", }}
                    data-aos="fade-left"
                    data-aos-delay="300"
                  >
                    Performance-driven digital marketing services in India
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Joinus
